module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_9006.57e37e97.png";